module.exports = __webpack_public_path__ + "5c411ba8e33d1e21c84dd503deaa7598.jpg";